import styled from 'styled-components';
import { Modal } from '../Modal';
import { motion } from 'framer-motion';

export const CalendarModal = styled(Modal)`
    background-color: blue !important;
`;

export const CalendarBackgroundModal = styled(motion.div)`
    width: 100%;
    height: 100%;

    background: rgb(0, 0, 0, 0.6);
    position: fixed;
    inset: 0;
    z-index: 3;

    display: flex;
    justify-content: center;
    align-items: start;
    padding: 2rem;

    overflow-y: auto;
    cursor: auto;
`;

export const CalendarModalWrapper = styled(motion.div)`
    width: clamp(30rem, 20vw, 70rem);
    height: fit-content;
    margin: auto;
    box-shadow: 0 0.3125rem 1rem rgba(0, 0, 0, 0.2);
    background: ${({ theme }) => theme.colors.primary};
    color: #000;
    position: relative;
    z-index: 10;
    border-radius: 0.625rem;
    padding: 1rem;

    display: flex;
    flex-direction: column;

    border-radius: 1.5rem;
`;

export const CalendarContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    flex-grow: 1;
    width: 100%;

    h2.title {
        font-family: 'Hero New';
        font-size: 1.5rem;
        font-style: normal;
        font-weight: 600;
        line-height: 1.5rem;
        text-align: center;
    }

    .buttons-wrapper {
        display: flex;
        gap: 0.75rem;
        width: 100%;

        > button {
            width: 100%;
        }
    }

    .line-divider {
        height: 1px;
        align-self: stretch;
        background-color: ${props => props.theme.colors['silver-200']};
    }

    .checkbox-wrapper {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        justify-content: center;

        > div:first-child {
            justify-content: center;
        }

        .row {
            display: flex;
            gap: 0.5rem;

            button {
                border-radius: 50%;

                svg {
                    /* opacity: 0; */
                    transform: scale(0.75);
                }
            }
        }
    }
`;

export const ReactCalendarWrapper = styled.div`
    position: relative;
    display: flex;
    flex-grow: 1;
    max-width: 35rem;
    .loading-wrapper {
        position: absolute;
        inset: 0;
        background-color: white;

        width: 100%;
        height: 100%;
        z-index: 10;

        display: flex;
        justify-content: center;
        align-items: center;

        .spinner {
            display: flex;
        }

        svg {
            width: 8rem;
            height: 8rem;
            color: #ffde0d;
        }
    }

    .react-calendar {
        display: flex;
        flex-direction: column;
        gap: 0.75rem;
        width: 100%;
        flex-flow: 1;
    }

    &.headless {
        pointer-events: none;

        button:not(.react-calendar__tile--rangeBothEnds) {
            cursor: not-allowed;
            pointer-events: none;
            span.price,
            .calendar-date-tag {
                display: none;
            }
            color: #c4c4c4 !important;
            /* background-color: transparent; */
        }
    }

    button {
        display: flex;
        justify-content: center;
        align-items: center;
        border: none;
        background: none;
        cursor: pointer;
        transition: 0.1s;
    }

    .react-calendar__tile {
        &:not(disabled):hover {
            background-color: #eee;
        }

        /* &.disabled {
            pointer-events: none;
            cursor: not-allowed;

            span.price {
                display: none;
            }
        } */

        &[disabled] {
            cursor: not-allowed;
            span.price,
            .calendar-date-tag {
                display: none;
            }
            color: #c4c4c4;

            background-color: transparent !important;
        }
    }

    .react-calendar__tile--rangeBothEnds {
        background-color: #ffcf00;
        transition: 0.2s;
        &:hover {
            background-color: #ffcf00;
        }
    }

    .react-calendar__navigation__label {
        pointer-events: none;
    }

    .react-calendar__navigation {
        display: flex;
        justify-content: space-between;
        padding: 0.25rem;

        .react-calendar__navigation__label__labelText {
            font-size: 1.25rem;
            font-weight: 700;
            color: ${props => props.theme.colors['neutral-950']};
        }
    }

    .react-calendar__month-view__weekdays__weekday {
        display: flex;
        justify-content: center;
    }
    .react-calendar__month-view__weekdays__weekday abbr {
        color: #888;
        border: none !important;
        text-decoration: none !important;
    }

    .react-calendar__navigation__prev2-button,
    .react-calendar__navigation__next2-button {
        display: none;
    }

    .react-calendar__month-view__days__day--neighboringMonth {
        color: #dfdfdf;
        span.price {
            opacity: 0;
        }
    }

    .react-calendar__month-view button {
        position: relative;
        aspect-ratio: 1.05/1;
        padding: 0.5rem;
        font-size: 1.25rem;
        font-style: normal;
        font-weight: 500;
        display: flex;
        flex-direction: column;
        color: #09090b;
        gap: 0.1rem;
        padding-top: 0.75rem;
        border-radius: 0.25rem;

        &.react-calendar__month-view__days__day--neighboringMonth {
            color: #c4c4c4;

            span.price {
                opacity: 0 !important;
            }
        }
    }

    .react-calendar__month-view button .calendar-date-tag {
        position: absolute;
        top: 0.5rem;
        width: 60%;
        z-index: 9;
        height: 2px;

        &.green {
            background: ${props => props.theme.colors['green-300']};
            color: ${props => props.theme.colors['neutral-950']};
        }

        &.orange {
            background: ${props => props.theme.colors['orange-300']};
        }

        &.red {
            background: ${props => props.theme.colors['red-300']};
        }
    }

    span.price {
        color: ${props => props.theme.colors['neutral-600']};
        font-size: 0.8125rem;
        line-height: 0.75rem;
        font-weight: 500;
    }

    .react-calendar__viewContainer,
    .react-calendar__year-view,
    .react-calendar__year-view__months {
        height: 100%;
    }

    .react-calendar__year-view .react-calendar__year-view__months {
        display: flex;

        > button {
            font-size: 1rem;
            font-weight: 500;
            border-radius: 0.25rem;
        }
    }
`;
